import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AsistenciaService } from '../_services/asistencia.service';


@Injectable()
export class TiposAsistenciaResolver  {

  constructor(
    private router: Router,
    private asistenciaService: AsistenciaService
  ) { }

  resolve(
    routeSnap: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return this.asistenciaService.tiposAsistencia$;
  }
}
